import ActionsMenu from './ActionsMenu'
import Button from './Button'
import Link from './Link'

const all = ActionsMenu
all.Button = Button
all.Link = Link

export default all
